export const PAGE_SIZE = 10;
export const ALL_GROUPS = 'AllGroups';
